import RangeSliderContainer from "../../Componant/BonusUI/RangeSlider";

const RangeSlider = () => {
  return (
    <div className="page-body">
      <RangeSliderContainer />
    </div>
  );
};

export default RangeSlider;
